import { types } from 'mobx-state-tree'

export const UserGroup = types.model('UserGroup').props({
  group_id: types.number,
  label: types.string,
  number_of_users: types.number,
})
